import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from '../components/navigation/Navigation';
import Footer from '../components/Footer';
import MyAccountModal from '../components/MyAccount/MyAccountModal';
import './MainLayout.css';

const MainLayout = () => {
  const [showAccountModal, setShowAccountModal] = useState(false);

  return (
    <div className="app-layout">
      <Navigation />
      <div className="my-account-container">
        <button 
          className="my-account-link"
          onClick={() => setShowAccountModal(true)}
        >
          My Account
        </button>
      </div>
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
      
      {showAccountModal && (
        <MyAccountModal onClose={() => setShowAccountModal(false)} />
      )}
    </div>
  );
};

export default MainLayout;